import React, { useState, useEffect } from 'react';
import lodash from 'lodash';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import LoginLayout from './LoginLayout';
import styles from './Login.scss';
import { setLoginEmailError, forgotPasswordV4 } from '../../actions/login';

const EMAIL_ADDRESS_PATTERN = /^[a-zA-Z0-9'._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const ForgetPassword = (props) => {
    const { setLoginEmailError, forgotPasswordV4, showPasswordResetEmailScreen } = props;

    const initialEmail = props.location.state && props.location.state.email ? props.location.state.email : '';

    const [email, setEmail] = useState(initialEmail);
    const [passwordResetSent, setPasswordResetSent] = useState(!showPasswordResetEmailScreen);

    const emailMatchesExpectedPattern = () => {
        return EMAIL_ADDRESS_PATTERN.test(email);
    };

    useEffect(() => {
        setPasswordResetSent(!showPasswordResetEmailScreen);
    }, [showPasswordResetEmailScreen]);

    const onSubmitClick = async (e) => {
        e.preventDefault();
        if(lodash.isEmpty(email)){
            setLoginEmailError('Please enter your email address.');
            return;
        }
        if (!emailMatchesExpectedPattern()) {
            setLoginEmailError('Please enter a valid email address.');
            return;
        }
        await forgotPasswordV4(email);
    };

    return (
        <LoginLayout >
            <div className={styles.heading}>
                <div className={styles.title}>{!passwordResetSent ? 'Password Reset Sent!' : 'Forgot Password?'}</div>
                <div className={styles.caption}>{!passwordResetSent ? 'Check your email for password reset instructions.' : 'No problem! We\'ll send you reset instructions.'}</div>
            </div>

            <form autoComplete="off" className={styles.form} onSubmit={onSubmitClick}>
                {passwordResetSent && <div className={styles.formGroup}>
                    <div className={styles.labelGroup}>
                        <label htmlFor="email" className={styles.inputLabelv4}>
                            Email Address
                        </label>
                    </div>

                    <input
                        id="email"
                        className={`${styles.inputv4} ${props.loginEmailError && styles.inputErrorv4}`}
                        type="text"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        autoFocus
                    />
                    {props.loginEmailError && <span className={styles.errorv4}>{props.loginEmailError}</span>}
                </div>}
                {passwordResetSent && <div className={styles.formGroup}>
                    <button type="submit" className={styles.actionButtonv4}>
                        Reset Password
                    </button>
                </div>}
                <div className={styles.backToSignIn}>
                    <Link to='/' className={styles.backToSignIn}> 
                        <FontAwesomeIcon
                            icon={faArrowLeft}
                        /> Back to sign in</Link>
                </div>
            </form>
        </LoginLayout>
    );
};

const mapStateToProps = (state) => ({
    clientData: lodash.get(state, 'application.config', {}),
    loginError: lodash.get(state, 'loginError', false),
    loginEmailError: lodash.get(state, 'loginEmailError', false),
    showPassword: lodash.get(state, 'showPassword', false),
    showPasswordResetEmailScreen: lodash.get(state, 'showPasswordResetEmailSentScreen', false),
});

export default connect(mapStateToProps, { setLoginEmailError, forgotPasswordV4 })(ForgetPassword);